import type { ValidationCheck } from '../types/checks.js';
import { AUTHENTICITY_CHECKS } from './groups/authenticity.js';
import { FACE_CHECKS } from './groups/face.js';
import { LIGHT_QUALITY_CHECKS } from './groups/lightQuality.js';
import { TECHNICAL_CHECKS } from './groups/technical.js';
import { aspectRatioCheck } from './aspectRatioCheck.js';
import { backgroundCheck } from './backgroundCheck.js';
import { compressionCheck } from './compressionCheck.js';
import { exposureCheck } from './exposureCheck.js';
import { eyeLineCheck } from './eyeLineCheck.js';
import { eyeOpenCheck } from './eyeOpenCheck.js';
import { faceCountCheck } from './faceCountCheck.js';
import { facePositionCheck } from './facePositionCheck.js';
import { facePoseCheck } from './facePoseCheck.js';
import { fileFormatCheck } from './fileFormatCheck.js';
import { fileSizeCheck } from './fileSizeCheck.js';
import { glassesCheck } from './glassesCheck.js';
import { headCoverageCheck } from './headCoverageCheck.js';
import { headSizeCheck } from './headSizeCheck.js';
import { imageSizeCheck } from './imageSizeCheck.js';
import { lightingCheck } from './lightingCheck.js';
import { noiseCheck } from './noiseCheck.js';
import { sharpnessCheck } from './sharpnessCheck.js';

export { aspectRatioCheck } from './aspectRatioCheck.js';
export { backgroundCheck } from './backgroundCheck.js';
export { compressionCheck } from './compressionCheck.js';
export { exposureCheck } from './exposureCheck.js';
export { eyeLineCheck } from './eyeLineCheck.js';
export { eyeOpenCheck } from './eyeOpenCheck.js';
export { faceCountCheck } from './faceCountCheck.js';
export { facePositionCheck } from './facePositionCheck.js';
export { facePoseCheck } from './facePoseCheck.js';
export { fileFormatCheck } from './fileFormatCheck.js';
export { fileSizeCheck } from './fileSizeCheck.js';
export { glassesCheck } from './glassesCheck.js';
export { headCoverageCheck } from './headCoverageCheck.js';
export { headSizeCheck } from './headSizeCheck.js';
export { imageSizeCheck } from './imageSizeCheck.js';
export { lightingCheck } from './lightingCheck.js';
export { noiseCheck } from './noiseCheck.js';
export { sharpnessCheck } from './sharpnessCheck.js';

/**
 * The default check set.
 *
 * Each check is an independent module with its own id, its own thresholds (read
 * from the document profile) and its own structured result. Adding a *document*
 * never touches this list; adding a *new kind of check* adds exactly one entry.
 */
export const DEFAULT_CHECKS: readonly ValidationCheck[] = [
  fileFormatCheck,
  fileSizeCheck,
  imageSizeCheck,
  aspectRatioCheck,
  faceCountCheck,
  facePositionCheck,
  headSizeCheck,
  eyeLineCheck,
  facePoseCheck,
  eyeOpenCheck,
  headCoverageCheck,
  glassesCheck,
  sharpnessCheck,
  exposureCheck,
  lightingCheck,
  noiseCheck,
  compressionCheck,
  backgroundCheck,
  // Extended check set (v1.2): grouped by the checklist category they appear
  // under. Adding a check means adding one entry in one group file.
  ...FACE_CHECKS,
  ...LIGHT_QUALITY_CHECKS,
  ...TECHNICAL_CHECKS,
  ...AUTHENTICITY_CHECKS,
];

/** Ids of all built-in checks, in UI order. */
export const CHECK_IDS: readonly string[] = DEFAULT_CHECKS.map((check) => check.id);
